export const dimensions = [
  {
    id: 'EI',
    name: '能量方向',
    poles: ['外向 (E)', '内向 (I)'],
    description: '你倾向于从外部世界还是内部世界获取能量'
  },
  {
    id: 'SN',
    name: '信息获取',
    poles: ['感觉 (S)', '直觉 (N)'],
    description: '你更倾向于关注具体的事实还是抽象的可能性'
  },
  {
    id: 'TF',
    name: '决策方式',
    poles: ['思考 (T)', '情感 (F)'],
    description: '你做决定时更依赖逻辑还是价值观和感受'
  },
  {
    id: 'JP',
    name: '生活方式',
    poles: ['判断 (J)', '知觉 (P)'],
    description: '你更喜欢有计划和条理还是灵活和适应'
  }
]

export const dimensionTraits = {
  E: {
    name: '外向',
    traits: ['从外部世界获取能量', '喜欢社交', '思考时倾向于说出来', '行动导向'],
    strengths: ['善于社交', '表达能力强', '适应环境快', '精力充沛'],
    challenges: ['独处时容易焦虑', '可能过度社交', '难以深入思考']
  },
  I: {
    name: '内向',
    traits: ['从内部世界获取能量', '需要独处时间', '深度思考', '反思导向'],
    strengths: ['专注力强', '思考深入', '独立性强', '观察细致'],
    challenges: ['社交压力大', '不善表达', '适应环境慢']
  },
  S: {
    name: '感觉',
    traits: ['关注现实和细节', '重视实际经验', '脚踏实地', '注重当下'],
    strengths: ['实践能力强', '注重细节', '执行力强', '现实主义'],
    challenges: ['可能忽视整体', '不善创新', '固守经验']
  },
  N: {
    name: '直觉',
    traits: ['关注可能性和模式', '重视想象力', '创新思维', '着眼未来'],
    strengths: ['创造力强', '洞察力强', '战略思维', '善于联想'],
    challenges: ['可能忽视细节', '不切实际', '难以落地']
  },
  T: {
    name: '思考',
    traits: ['基于逻辑做决定', '追求客观公正', '重视效率', '分析导向'],
    strengths: ['逻辑性强', '决策客观', '问题解决能力强', '公正'],
    challenges: ['可能忽视感受', '显得冷漠', '人际关系处理']
  },
  F: {
    name: '情感',
    traits: ['基于价值观做决定', '重视和谐关系', '富有同理心', '关注他人感受'],
    strengths: ['人际关系好', '同理心强', '善解人意', '价值观导向'],
    challenges: ['决策可能不够客观', '容易情绪化', '难以拒绝']
  },
  J: {
    name: '判断',
    traits: ['喜欢计划和组织', '追求秩序', '目标导向', '及时完成任务'],
    strengths: ['组织能力强', '执行力强', '可靠', '有条理'],
    challenges: ['缺乏灵活性', '压力大', '完美主义']
  },
  P: {
    name: '知觉',
    traits: ['灵活适应', '保持开放', '享受过程', '随机应变'],
    strengths: ['适应力强', '创造力强', '开放包容', '灵活'],
    challenges: ['难以做决定', '拖延', '缺乏计划性']
  }
} 